getNextEventHandler